import { render } from "./VideoSlot.vue?vue&type=template&id=152b7a3a&scoped=true&ts=true&lang=pug"
import script from "./VideoSlot.vue?vue&type=script&lang=ts"
export * from "./VideoSlot.vue?vue&type=script&lang=ts"

import "./VideoSlot.vue?vue&type=style&index=0&id=152b7a3a&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-152b7a3a"]])

export default __exports__